module.exports = "SELECT round(unnest(CDB_JenksBins(array_agg(area_km2::numeric),5)),1) as bucket\nFROM fsp_voronoid\nWHERE type_id = {type_id}\n"